import type { VaultRevealPurpose, VaultRotationReason, VaultRotationResolution } from '../contracts/vault';

export const VAULT_ROTATION_REASON_LABELS: Record<VaultRotationReason, string> = {
  member_left: 'Osoba z dostępem odeszła z zespołu',
  yearly: 'Minął rok od zmiany hasła',
};

export const VAULT_ROTATION_RESOLUTION_LABELS: Record<VaultRotationResolution, string> = {
  changed: 'Hasło zmienione',
  dismissed: 'Pominięte',
};

export const VAULT_REVEAL_PURPOSE_LABELS: Record<VaultRevealPurpose, string> = {
  reveal: 'Podgląd hasła',
  copy: 'Skopiowano hasło',
};
